import { render, staticRenderFns } from "./SubEntryGroupingTable.vue?vue&type=template&id=51cbcb37&scoped=true&"
import script from "./SubEntryGroupingTable.vue?vue&type=script&lang=ts&"
export * from "./SubEntryGroupingTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubEntryGroupingTable.vue?vue&type=style&index=0&id=51cbcb37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cbcb37",
  null
  
)

export default component.exports